import React from 'react';
import { Route } from 'react-router-dom';
import rolesStore from '../../../store/rolesStore';
import { SCREENS } from 'src/constants/screens';
import { Table } from 'src/view/components/Table/Table';
import Headers from 'src/view/containers/Headers/Headers';
import HeaderBack from 'src/view/containers/Headers/components/HeaderBack/HeaderBack';
import ScreenTabsNavigation from 'src/view/containers/ScreenTabsNavigation/ScreenTabsNavigation';
import AllUsers from 'src/view/screens/SettingsScreen/screens/General/ManageUsers/screens/AllUsers/AllUsers';
import UserRoles from 'src/view/screens/SettingsScreen/screens/General/ManageUsers/screens/UserRoles/UserRoles';

const ManageUsers = () => {
  rolesStore.setHideRoles([]);

  return (
    <div className="d-flex flex-column full-width">
      <Headers>
        <HeaderBack title="Manage_users" path={SCREENS.SETTINGS()} />
      </Headers>
      <div className="d-flex flex-column flex-grow-1 pt-6">
        <Table>
          <>
            <ScreenTabsNavigation
              options={[
                { path: SCREENS.SETTINGS_USERS(), title: 'all_users' },
                { path: SCREENS.SETTINGS_USER_ROLES(), title: 'user_roles' },
              ]}
            />
            <Route path={SCREENS.SETTINGS_USERS()} component={AllUsers} />
            <Route path={SCREENS.SETTINGS_USER_ROLES()} component={UserRoles} />
          </>
        </Table>
      </div>
    </div>
  );
};

export default ManageUsers;
